import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Training from "@/pages/Training";
import ModuleDetail from "@/pages/ModuleDetail";
import Troubleshooting from "@/pages/Troubleshooting";
import GuidedTroubleshooting from "@/pages/GuidedTroubleshooting";
import Workflow from "@/pages/Workflow";
import Videos from "@/pages/Videos";
import SpareParts from "@/pages/SpareParts";
import Contacts from "@/pages/Contacts";
import Templates from "@/pages/Templates";
import Safety from "@/pages/Safety";
import Technician from "@/pages/Technician";
import Admin from "@/pages/Admin";

const page = (el) => (
  <ProtectedRoute>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrandingProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={page(<Dashboard />)} />
            <Route path="/training" element={page(<Training />)} />
            <Route path="/training/:id" element={page(<ModuleDetail />)} />
            <Route path="/troubleshooting" element={page(<Troubleshooting />)} />
            <Route path="/guided/:id" element={page(<GuidedTroubleshooting />)} />
            <Route path="/workflow" element={page(<Workflow />)} />
            <Route path="/videos" element={page(<Videos />)} />
            <Route path="/spare-parts" element={page(<SpareParts />)} />
            <Route path="/contacts" element={page(<Contacts />)} />
            <Route path="/templates" element={page(<Templates />)} />
            <Route path="/safety" element={page(<Safety />)} />
            <Route path="/technician" element={page(<Technician />)} />
            <Route path="/admin" element={
              <ProtectedRoute adminOnly>
                <Layout><Admin /></Layout>
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
      </BrandingProvider>
    </div>
  );
}

export default App;
